// const mockData = {
//   id: null,
//   jobTitle: 'Apprenticeship in Jira and GDPR',
//   company: 1,
//   programme: 3,
//   jobRoles: [1, 5],
//   startYear: [2016],
//   programmeLength: 1,
//   salaryFrequency: 1,
//   salary: 10000,
//   region: [1],
//   providerKnown: false,
//   provider: 1,
//   temp_comp_name: null,
//   temp_training_provider_name: null,
//   temp_location_name: '',
//   reviewLocations: [],
// };

const emptyData = {
  id: null,
  jobTitle: null,
  company: null,
  programme: null,
  jobRoles: [],
  startYear: null,
  programmeLength: null,
  salaryFrequency: null,
  salary: null,
  region: null,
  providerKnown: null,
  provider: false,
  temp_comp_name: null,
  temp_training_provider_name: null,
  temp_location_name: '',
  reviewLocations: [],
};

export default function () {
  // return mockData;
  return emptyData; // eslint-disable-line
}
